import {createApp} from "vue";
import App from "./App.vue";
import router from "./router";
import ArgonDashboard from "./plugins/argon-dashboard";
import "element-plus/dist/index.css";
import {store} from './store';
import Keycloak from 'keycloak-js';
import CKEditor from '@ckeditor/ckeditor5-vue';
import VueGridLayout from 'vue-grid-layout';

import Toast from "vue-toastification";
import "vue-toastification/dist/index.css";

const options = {containerClassName: "ct-notification"};

const appInstance = createApp(App);
appInstance.use(router);
appInstance.use(Toast, options);
appInstance.use(ArgonDashboard);
appInstance.use(CKEditor);
appInstance.use(store);
appInstance.use(VueGridLayout);

const keycloak = new Keycloak({
    url: 'https://auth.mytalus.ch',
    clientId: 'tok-frontend',
    realm: 'TOK'
});

keycloak.init({
    onLoad: 'check-sso',
}).then((auth) => {
    if (auth) {
        const user = JSON.stringify(keycloak.tokenParsed, null, "  ");
        localStorage.setItem('user', user);
        localStorage.setItem('token', keycloak.token);
        localStorage.setItem('idToken', keycloak.idToken);
        store.commit('auth/loginSuccess', JSON.parse(localStorage.getItem('user')), localStorage.getItem('token'), localStorage.getItem('idToken'));
        //Token Refresh
        setInterval(() => {
            keycloak.updateToken(30).then((refreshed) => {
                if (refreshed) {
                    localStorage.setItem('token', keycloak.token);
                }
            }).catch(() => {
                console.log('Failed to refresh token');
            });
        }, 6000)
        appInstance.mount("#app");
        router.push(localStorage.getItem('loginRedirect'));
    } else {
        store.commit('auth/logout');
        localStorage.removeItem('user');
        localStorage.removeItem('token');
        appInstance.mount("#app");
        if(localStorage.getItem('loginRedirect') !== '') {
            router.push(localStorage.getItem('loginRedirect'));
        } else {
            router.push('/');
        }
    }
}).catch(() => {

});

